import normalizeThemeId from '../utils/normalizeThemeId';
import { ThemeResources, ThemeConstants } from 'owa-theme-shared';
import {
    getThemeIdFromParameter,
    getIsDarkThemeFromParameter,
    isBookingsV2,
} from '../utils/optionalArgumentHelpers';
import { fetchThemeResource } from './fetchThemeResource';
import { shouldUseCobranding, getCobrandingThemeResources } from 'owa-theme-common';

export default function getResourcesForTheme(
    themeId?: string,
    isDarkTheme?: boolean
): ThemeResources {
    themeId = getThemeIdFromParameter(themeId);
    isDarkTheme = getIsDarkThemeFromParameter(isDarkTheme);
    let normalizedTheme = normalizeThemeId(themeId);

    if (shouldUseCobranding(normalizedTheme, isDarkTheme)) {
        return getCobrandingThemeResources();
    } else if (
        isBookingsV2() &&
        (normalizedTheme === ThemeConstants.BASE_THEME_ID ||
            normalizedTheme === ThemeConstants.BASE_OFFICE_THEME_ID)
    ) {
        normalizedTheme = 'base.bookings';
    }

    return fetchThemeResource(normalizedTheme, isDarkTheme) as ThemeResources;
}
